import { render, staticRenderFns } from "./SupplyChamber.vue?vue&type=template&id=538e5fbc"
import script from "./SupplyChamber.vue?vue&type=script&lang=js"
export * from "./SupplyChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports